import React, { Fragment, useState } from 'react';
import {
    ShowButton,
    SimpleShowLayout,
    List,
    Edit,
    Create,
    Datagrid,
    TextField,
    EditButton,
    ShowController,
    ShowView,
    SelectInput,
    SimpleForm,
    TextInput,
    Filter,
    FormDataConsumer,
    ArrayInput,
    SimpleFormIterator,
    ImageField,
    ArrayField,
    BooleanField,
    BooleanInput,
    ImageInput,
    SelectArrayInput,
    NumberInput,
    NumberField,
    ReferenceInput,
    AutocompleteInput,
    useNotify,
    useRecordContext,
    TabbedForm,
    FormTab,
    useRedirect,
    useRefresh,
    FileInput,
    FileField,
    Show,
    WithRecord,
    DateField,
} from 'react-admin';
import { useParams } from 'react-router-dom';

import client from '../common/client';
import {
    Button, Box, CircularProgress, TextField as ReactTextField,
    Grid, Card, CardActions, CardContent, CardHeader,
    Divider
} from '@mui/material';

import Help from '../component/Help'
import JavascriptInput from '../component/JavascriptInput'
import ProjectVersionField from './ProjectVersionField'
import ProjectLoadingField from './ProjectLoadingField'
import ProjectBackendResourceDistribution from './ProjectBackendResourceDistribution'
import ProjectFrontConfigDistribution from './ProjectFrontConfigDistribution'
import ProjectFrontS3Create from './ProjectFrontS3Create'
import ProjectBackendConfigDistribution from './ProjectBackendConfigDistribution'
import ProjectBackendS3Create from './ProjectBackendS3Create'
import ProjectAndroidConfigDistribution from './ProjectAndroidConfigDistribution'
import ProjectIosConfigDistribution from './ProjectIosConfigDistribution'

const AuthList =
    [
        { id: 'owner', name: 'Owner' },
        { id: 'manager', name: 'Editor' },
        { id: 'normal', name: 'Viewer' },
    ];

const ProjectFilter = props => (
    <Filter {...props}>
        <TextInput resettable label="Project Name" source="name" alwaysOn />
    </Filter>
);



const DeployButtonField = ({ record = {} }) => {
    const [loading, setLoading] = React.useState(false)
    const handleClick = (e) => {
        setLoading(true)
        client.request_get(`/api/deploy/project/${record.id}`).then(res => {
            setLoading(false)
            if (res.r) {
                alert(`Deploy Complte ${res.version}`)
            }
        })
    }
    return (
        <Button color="primary" onClick={(e) => { handleClick(e) }}>
            {loading && <CircularProgress size={20} />}
            {!loading && `Deploy(Json & Image To S3)`}
        </Button>
    )
}
DeployButtonField.defaultProps = { label: 'Package' };

export const ProjectList = props => {
    return (
        <List title="Project" {...props} filters={<ProjectFilter />}
            exporter={false}
            perPage={25}
            sort={{ field: 'name', order: 'ASC' }}>
            <Datagrid rowClick="show">
                <TextField label="ID" source="id" />
                <TextField label="Project Name" source="name" />
                <TextField label="App Name" source="app_name" />
                <TextField label="Distribution Version" source="version" />
                <NumberField label="Screen" source="screen_count" />
                <DateField label="Reg" source="reg_date" />
                {/* <DeployButtonField label="deploy(S3)"/> */}
                <EditButton />
            </Datagrid>
        </List>
    )
};

const ProjectTitle = ({ record }) => {
    return <span>Project {record ? `"${record.name}"` : ''}</span>;
};

const required = (message = 'Required') =>
    value => value ? undefined : message;
const maxLength = (max, message = 'Too Long') =>
    value => value && value.length > max ? message : undefined;
const validateRequireAndLength = [required(), maxLength(100)];

export const ProjectCreate = props => (
    <Create title={<ProjectTitle />} {...props} mutationMode='pessimistic'>
        <SimpleForm>
            <TextInput resettable label="Project Name" source="name" validate={validateRequireAndLength} />
            <TextInput resettable label="App Name" source="app_name" validate={validateRequireAndLength} />

            <BooleanInput label="Android App" source="android" defaultValue={false} />
            <FormDataConsumer>
                {({ formData, ...rest }) =>
                    (formData.android) && (
                        <Box>
                            <TextInput resettable label="Android Package Name" source="android_package" />
                            <br />
                            <TextInput fullWidth={true} resettable label="Github Repository" source="android_git" />
                            <TextInput fullWidth={true} resettable label="Github Token" source="android_git_token" />
                        </Box>
                    )
                }
            </FormDataConsumer>

            <BooleanInput label="iOS App" source="ios" defaultValue={false} />

            <FormDataConsumer>
                {({ formData, ...rest }) =>
                    (formData.ios) && (
                        <Box>
                            <TextInput resettable label="iOS Package Name" source="ios_package" /><br />
                            <TextInput fullWidth={true} resettable label="Github Repository" source="ios_git" /><br />
                            <TextInput resettable label="Github Token" source="ios_git_token" /><br />
                            <TextInput resettable label="App Store Connect Team ID" source="ios_itc_team_id" /><br />
                            <TextInput resettable label="Developer Portal Team ID" source="ios_team_id" /><br />
                        </Box>
                    )
                }
            </FormDataConsumer>

        </SimpleForm>
    </Create>
);


export const ProjectEdit = props => {
    const notify = useNotify();
    const { id } = useParams()

    const onSuccess = () => {
        notify(`Changes saved`)
        //redirect(props.location.pathname);
        //refresh();
    };

    return (
        <Edit redirect={false} title={<ProjectTitle />} onSuccess={onSuccess} {...props} mutationMode='pessimistic'>
            <TabbedForm>
                <FormTab label="base">
                    <TextInput resettable label="App Name" source="app_name" validate={validateRequireAndLength} />

                    <BooleanInput label="Android App" source="android" defaultValue={false} />
                    <FormDataConsumer>
                        {({ formData, ...rest }) =>
                            (formData.android) && (
                                <Box>
                                    <TextInput resettable label="Android Package Name" source="android_package" />
                                    <br />
                                    <TextInput fullWidth={true} resettable label="Github Repository" source="android_git" />
                                    {formData.is_own && <TextInput resettable label="Github Token" source="android_git_token" />}
                                </Box>
                            )
                        }
                    </FormDataConsumer>

                    <BooleanInput label="iOS App" source="ios" defaultValue={false} />

                    <FormDataConsumer>
                        {({ formData, ...rest }) =>
                            (formData.ios) && (
                                <Box>
                                    <TextInput resettable label="iOS Package Name" source="ios_package" /><br />
                                    <TextInput fullWidth={true} resettable label="Github Repository" source="ios_git" /><br />
                                    {formData.is_own && <TextInput resettable label="Github Token" source="ios_git_token" />}<br />
                                    <TextInput resettable label="APp Store Team ID" source="ios_team_id" /><br />
                                    <TextInput resettable label="App Store ICT Team ID" source="ios_itc_team_id" /><br />
                                </Box>
                            )
                        }
                    </FormDataConsumer>
                    <ImageInput source="img" label="icon" accept="image/png" placeholder={<p>App Icon(Should be png)</p>}>
                        <ImageField source="src" title="title" sx={{
                            "& .RaImageField-image": { width: "100px" },
                        }} />
                    </ImageInput>


                    <ImageInput source="android_notification_icon" label="Notification Icon(Android Only)" accept="image/png" placeholder={<p><Help url='https://devilappbuilder.tistory.com/2' />Android Only Notification Icon(Should be png) Background should be TransParent, symbol icon should be white</p>}>
                        <ImageField source="src" title="title" />
                    </ImageInput>
                    <TextInput resettable label="android_notification_icon_color(#ffffff)" source="android_notification_color" />
                </FormTab>
                <FormTab label="Http Config">
                    <TextInput label="API Host Address(http://...)" sx={{ width: 250 }} source="host" />
                    <TextInput label="Web Host Address(http://...)" sx={{ width: 250 }} source="web_host" />

                    <ArrayInput label="Header List" source="header_list">
                        <SimpleFormIterator>
                            <TextInput label="Header Name" source="header" validate={validateRequireAndLength} />
                            <TextInput label="Content" source="content" validate={validateRequireAndLength} />
                        </SimpleFormIterator>
                    </ArrayInput>

                    <ArrayInput label="Config List" source="config_list">
                        <SimpleFormIterator>
                            <TextInput label="Name" source="name" validate={validateRequireAndLength} />
                            <TextInput label="Value" source="value" validate={validateRequireAndLength} />
                        </SimpleFormIterator>
                    </ArrayInput>
                </FormTab>
                <FormTab label="Collaborators">
                    <ArrayInput label="Collaborator" source="user_list">
                        <SimpleFormIterator>
                            <ReferenceInput source="member_no" reference="user"
                                sort={{ field: 'email', order: 'ASC' }}
                            >
                                <AutocompleteInput label="사용자" optionText="email" sx={{ width: '300px' }} />
                            </ReferenceInput>
                            <SelectInput resettable label="유형" source="type" choices={AuthList} optionText="name" optionValue="id" alwaysOn />
                        </SimpleFormIterator>
                    </ArrayInput>
                </FormTab>
                <FormTab label="Common Code">
                    <JavascriptInput fullWidth={true} label="Common Javascript" source="common_javascript" />
                </FormTab>

                <FormTab label="App Decoration">
                    <BooleanInput label="UIStatusBarStyleLightContent(iOS Only)" source="status_bar_style_light_content" defaultValue={false} />
                    <TextInput label="Android Status Bar Color(#ffffff)" source="android_statusbar_color" sx={{ width: 300 }} />
                    <TextInput label="Android Navigation Bar Color(#ffffff)" source="android_navigationbar_color" sx={{ width: 300 }} />
                    <TextInput label="Place Holder Image Url(http://...)" source="place_holder" fullWidth />
                    <TextInput label="Place Holder Image Url Small" source="place_holder_small" fullWidth />
                    <TextInput label="Place Holder Image Url Larget" source="place_holder_large" fullWidth />

                    <FileInput source="loading" label="Loading Lottie Json(Git)" accept="application/json" placeholder={<p>Loading Lottie Json(Git) <br />
                        <a href="https://lottiefiles.com/search?q=loading&category=animations">https://lottiefiles.com/search?q=loading&category=animations</a></p>}>
                        <FileField source="src" title="title" />
                    </FileInput>
                    <BooleanInput label="Default Word Wrap" source="default_word_wrap" sx={{ width: 300 }} />
                    <BooleanInput label="Use Theme" source="use_theme" defaultValue={false} />
                </FormTab>

                <FormTab label="Development">
                    <ArrayInput label="Dev Host Address" source="dev_host_list">
                        <SimpleFormIterator>
                            <TextInput label="API Host" sx={{ width: 250 }} source="host" />
                            <TextInput label="Web Host" sx={{ width: 250 }} source="web_host" />
                        </SimpleFormIterator>
                    </ArrayInput>

                    <Help title="Dev Menu" url="https://devilappbuilder.tistory.com/4" type="button" />
                    <ArrayInput label="Dev Menu" source="dev_menu_list">
                        <SimpleFormIterator>
                            <TextInput label="Menu Name" source="name" />
                            <JavascriptInput fullWidth={true} height='100px' label="Action Script" source="script" />
                        </SimpleFormIterator>
                    </ArrayInput>

                    <ArrayInput label="Debug View" source="debug_view_udid_list">
                        <SimpleFormIterator>
                            <ReferenceInput label="Device" source="udid" reference="device" filter={{ project_id: id }}>
                                <SelectInput optionText="name" />
                            </ReferenceInput>
                        </SimpleFormIterator>
                    </ArrayInput>
                </FormTab>

                <FormTab label="App Log">
                    <ArrayInput label="Device UDID" source="device_log_udid_list">
                        <SimpleFormIterator>
                            <ReferenceInput label="Device" source="udid" reference="device" filter={{ project_id: id }}>
                                <SelectInput optionText="name" />
                            </ReferenceInput>
                        </SimpleFormIterator>
                    </ArrayInput>
                </FormTab>

                <FormTab label="Front & Backend">
                    <FormDataConsumer>
                        {({ formData, ...rest }) =>
                            (formData.front || formData.backend) && (
                                <Box sx={{ width: '100%' }}>
                                    {formData.is_own && <TextInput resettable label="AWS access id" source="aws_access_id" />}<br />
                                    {formData.is_own && <TextInput resettable label="AWS secret key" source="aws_secret_key" />}<br />
                                    {formData.is_own && <TextInput resettable label="AWS region" source="aws_region" />}<br />
                                    {formData.is_own && <TextInput resettable label="Mongo DB url" source="db_url" fullWidth />}<br />
                                    {formData.is_own && <TextInput resettable label="Base Server Port Prefix(XX00)" source="base_port" />}<br />
                                    {formData.is_own && <TextInput resettable label="Host Image(http)" source="host_image" fullWidth/>}<br />
                                    {formData.is_own && <TextInput resettable label="Slack Token" source="slack_token" />}<br />
                                    {formData.is_own && <TextInput resettable label="Slack Channel Id" source="slack_channel_id" />}<br />
                                </Box>
                            )
                        }
                    </FormDataConsumer>

                    <BooleanInput label="Front Server" source="front" defaultValue={false} />
                    <FormDataConsumer>
                        {({ formData, ...rest }) =>
                            (formData.front) && (
                                <Box sx={{ width: '100%' }}>
                                    <TextInput resettable label="Github Repository" source="front_git" fullWidth />
                                    {formData.is_own && <TextInput resettable label="Github Token" source="front_git_token" fullWidth />}
                                    <TextInput resettable label="S3 bucket www" source="front_s3_www" /><br />
                                    <TextInput resettable label="S3 bucket image" source="front_s3_image" /><br />
                                    <TextInput resettable label="S3 bucket private" source="front_s3_private" /><br />
                                </Box>
                            )
                        }
                    </FormDataConsumer>

                    <BooleanInput label="Backend Server" source="backend" defaultValue={false} />
                    <FormDataConsumer>
                        {({ formData, ...rest }) =>
                            (formData.backend) && (
                                <Box sx={{ width: '100%' }}>
                                    <TextInput resettable label="Github Repository" source="backend_git" fullWidth />
                                    {formData.is_own && <TextInput resettable label="Github Token" source="backend_git_token" fullWidth />}
                                    <TextInput resettable label="S3 bucket admin" source="backend_s3_admin" /><br />
                                    {/* <TextInput resettable label="Admin api host(http,https)" source="admin_host" fullWidth /> */}
                                </Box>
                            )
                        }
                    </FormDataConsumer>
                </FormTab>
            </TabbedForm>
        </Edit>
    )
};

export const ProjectShow = ({ ...props }) => {
    const { id } = useParams()
    const notify = useNotify();
    const [loading, setLoading] = React.useState(false);
    const [loading2, setLoading2] = React.useState(false);
    const handleClickIconToGithub = (e) => {
        setLoading(true)
        client.request_get(`/api/github/project/icon/${id}`).then(res => {
            setLoading(false)
            if (res.r) {
                notify(`Generate Success`);
            } else {
                notify(`${res.msg}`);
            }
        }).catch(e => {
            setLoading(false)
            notify(`${e}`);
        })
    }

    const handleClickJsonToGithub = (e) => {
        setLoading(true)
        client.request_get(`/api/github/project/json/${id}`).then(res => {
            setLoading(false)
            if (res.r) {
                notify(`Generate Success`);
            } else {
                notify(`${res.msg}`);
            }
        }).catch(e => {
            setLoading(false)
            notify(`${e}`);
        })
    }

    const handleClickInitializeToGithub = (e) => {
        setLoading(true)
        client.request_get(`/api/github/project/initialize/${id}`).then(res => {
            setLoading(false)
            if (res.r) {
                notify(`Generate Success`);
            } else {
                notify(`${res.msg}`);
            }
        }).catch(e => {
            setLoading(false)
            notify(`${e}`);
        })
    }

    return (
        <Show>
            <SimpleShowLayout>
                <TextField label="Project Name" source="name" />
                <Box mt={3} mb={3}>
                    <Divider>App Distribution</Divider>
                </Box>
                <Box mt={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={4}>
                            <Card >
                                <CardHeader
                                    title="Icon & Asset"
                                    action={
                                        <Help />
                                    }
                                />
                                <CardContent>
                                    <Box>
                                        <WithRecord label="icon" render={record => record.img ? <img width="100" src={record.img.src} /> : <div />} />
                                    </Box>
                                    <Box mt={1}>
                                        <Button startIcon={loading && <CircularProgress size={24} />} variant="contained" color="secondary" onClick={handleClickIconToGithub} disabled={loading}>
                                            Icon To Github</Button>
                                    </Box>
                                    <Box mt={1}>
                                        <Button startIcon={loading && <CircularProgress size={24} />} variant="contained" color="primary" onClick={handleClickJsonToGithub} disabled={loading2}>
                                            JSON & Image To Github
                                        </Button>
                                    </Box>

                                </CardContent>
                                <CardActions>

                                </CardActions>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <WithRecord render={record => <ProjectVersionField project={record} />} />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <WithRecord render={record => <ProjectLoadingField project={record} />} />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <WithRecord render={record => <ProjectAndroidConfigDistribution project={record} />} />
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <WithRecord render={record => <ProjectIosConfigDistribution project={record} />} />
                        </Grid>
                    </Grid>
                </Box>

                <WithRecord render={record =>
                    record && record.front ? <Box>
                        <Box mt={3} mb={3}>
                            <Divider>Front Distribution</Divider>
                            <Box mt={3}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <ProjectFrontS3Create project={record} />
                                    </Grid>
                                    <Grid item xs={12} md={6} lg={4}>
                                        <ProjectFrontConfigDistribution project={record} />
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </Box> : <Box></Box>
                } />
                <WithRecord render={record =>
                    record && record.backend ? <Box>
                        <Box mt={3} mb={3}>
                            <Divider>Backend Distribution</Divider>
                        </Box>
                        <Box mt={3}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={6} lg={4}>
                                    <ProjectBackendResourceDistribution project={record} />
                                </Grid>
                                <Grid item xs={12} md={6} lg={4}>
                                    <ProjectBackendS3Create project={record} />
                                </Grid>
                                <Grid item xs={12} md={6} lg={4}>
                                    <ProjectBackendConfigDistribution project={record} />
                                </Grid>
                            </Grid>
                        </Box>
                    </Box> : <Box></Box>
                } />


            </SimpleShowLayout>
        </Show>
    )
};
